import type { FieldType } from '@kizen/api';
import type { LogActivityFieldValue } from './eval';
import type { VisibilityRule } from './types';

import { useSelector } from 'react-redux';
import { evalRules, getFieldValues, getRuleEvalMap } from './eval';

type UseActivityRulesResult = {
  /**
   * @param id - a field's id or text block's internal_name
   */
  isRuleActiveForLayoutItem(id: string): boolean;
};

export const useActivityRules = (
  visibilityRules: VisibilityRule[],
  values: LogActivityFieldValue[]
): UseActivityRulesResult => {
  const currentUser = useSelector((s: any) => s.authentication.teamMember);
  const rules = getRuleEvalMap(visibilityRules);
  const fieldTypes = values.reduce<Record<string, FieldType>>((acc, field) => {
    acc[field.id] = field.fieldType;
    return acc;
  }, {});
  const ruleResults = evalRules({
    currentUserId: currentUser.id,
    fieldTypes,
    rules,
    values: Array.isArray(values) ? getFieldValues(values) : values,
  });

  const isRuleActiveForLayoutItem = (id: string) => {
    return !rules.has(id) || ruleResults[id];
  };

  return { isRuleActiveForLayoutItem };
};
